.advanced-ticket-selection {
  max-width: 600px;
  margin: auto;
}
.advanced-ticket-selection .promo-proposal {
  margin: auto;
}
.advanced-ticket-selection table {
  min-width: 100%;
}
.advanced-ticket-selection table td {
  padding: 3px;
  font-weight: bold;
}
.advanced-ticket-selection table td.right {
  text-align: right;
  min-width: 155px;
}
.advanced-ticket-selection table td.top {
  vertical-align: text-top;
  padding-top: 8px;
}
.advanced-ticket-selection table td.no-width {
  min-width: 0;
}
.advanced-ticket-selection .content-box-magnifier-image, .advanced-ticket-selection .content-box-plan-image {
  width: 100px;
  margin: 10px;
}
.advanced-ticket-selection .action {
  margin: 4px 2px;
  text-align: right;
}
.advanced-ticket-selection .alert-danger {
  max-width: 99%;
}
.advanced-ticket-selection .fa-search {
  color: #000;
  font-size: 90px;
}
@media screen and (max-width: 500px) {
  .advanced-ticket-selection .advanced-ticket-selection {
    max-width: 100%;
  }
  .advanced-ticket-selection .content-box-magnifier-image {
    display: none;
  }
  .advanced-ticket-selection .content-box-plan-image {
    width: 20vw;
    max-width: 85px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */